<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C12.42,0,16,3.58,16,8C16,12.06,12.98,15.4,9.06,15.92C9.04,15.92,9.02,15.93,9,15.93C8.67,15.97,8.34,16,8,16C3.58,16,0,12.42,0,8C0,7.45,0.45,7,1,7C1.55,7,2,7.45,2,8C2,11.31,4.69,14,8,14C8.71,14,9.37,13.85,10,13.62C10,13.62,10,13.63,10,13.63C12.33,12.81,14,10.61,14,8C14,4.69,11.31,2,8,2C6.22,2,4.64,2.78,3.54,4C3.54,4,5,4,5,4C5.55,4,6,4.45,6,5C6,5.55,5.55,6,5,6C5,6,1,6,1,6C0.45,6,0,5.55,0,5C0,5,0,1,0,1C0,0.45,0.45,0,1,0C1.55,0,2,0.45,2,1C2,1,2,2.74,2,2.74C3.46,1.07,5.6,0,8,0C8,0,8,0,8,0ZM9,12C9,12,7,12,7,12C7,12,7,10,7,10C7,10,9,10,9,10C9,10,9,12,9,12C9,12,9,12,9,12ZM9,9C9,9,7,9,7,9C7,9,7,4,7,4C7,4,9,4,9,4C9,4,9,9,9,9C9,9,9,9,9,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Outdated',
} as DefineComponent
</script>
